function initAllGlossaryDrawers() {
  const glossaries = document.querySelectorAll('[id^="GlossaryWidget-"]:not([data-initialized])');
  
  glossaries.forEach(wrapper => {
    wrapper.setAttribute('data-initialized', 'true');
    const sectionId = wrapper.id.replace('GlossaryWidget-', '');
    
    const newOverlay = document.getElementById(`piw-overlay-${sectionId}`);
    const body = document.body;
    const grid = document.getElementById(`GlossaryGrid-${sectionId}`);

    if (newOverlay && newOverlay.parentNode !== body) {
      body.appendChild(newOverlay);
    }

    function openDrawer(handle) {
      let drawer = document.getElementById(`piw-drawer-${sectionId}-${handle}`);
      
      // --- NEW TEMPLATE CLONE LOGIC ---
      // If the drawer isn't in the DOM yet, build it from the template
      if (!drawer) {
        const template = document.getElementById(`template-drawer-${sectionId}-${handle}`);
        if (template) {
          body.appendChild(template.content.cloneNode(true));
          // Now that it's appended, grab the element
          drawer = document.getElementById(`piw-drawer-${sectionId}-${handle}`);
        }
      }
      // --------------------------------

      if(drawer) {
        drawer.classList.add('is-open');
        if(newOverlay) newOverlay.classList.add('is-active');
        body.style.overflow = 'hidden'; 
        
        // --- AJAX LAZY LOAD LOGIC ---
        const productContainer = drawer.querySelector('.piw-drawer-slider');
        
        if (productContainer && productContainer.dataset.loaded === 'false') {
          const query = productContainer.dataset.searchQuery;
          
          if (query) {
            fetch(`${window.Shopify.routes?.root || '/'}search?type=product&q=${encodeURIComponent(query)}&section_id=ajax-product-cards`)
              .then(response => response.text())
              .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const listItems = doc.querySelectorAll('li');
                
                productContainer.innerHTML = ''; 
                
                if (listItems.length > 0) {
                  listItems.forEach(li => productContainer.appendChild(li));
                } else {
                  productContainer.innerHTML = '<p style="padding-left: 20px; opacity: 0.6;">Products currently unavailable.</p>';
                }
                
                productContainer.dataset.loaded = 'true';
              })
              .catch(err => {
                console.error('Failed to load products', err);
                productContainer.innerHTML = '<p>Failed to load products.</p>';
              });
          }
        }
        // --- END AJAX LAZY LOAD LOGIC ---
      }
    }

    if (grid && !grid.dataset.listenerAttached) {
      grid.addEventListener('click', (e) => {
        const tile = e.target.closest('.glossary-tile');
        if (tile) {
          if (window.getSelection().toString().length > 0) return; 
          openDrawer(tile.getAttribute('data-drawer-trigger'));
        }
      });
      grid.dataset.listenerAttached = 'true';
    }
  });

  if (!window.glossaryGlobalCloseAttached) {
    document.body.addEventListener('click', (e) => {
      const isCloseBtn = e.target.closest('.piw-drawer-close');
      const isOverlay = e.target.classList.contains('piw-drawer-overlay');

      if (isCloseBtn || isOverlay) {
        document.querySelectorAll('.piw-drawer.is-open').forEach(d => d.classList.remove('is-open'));
        document.querySelectorAll('.piw-drawer-overlay.is-active').forEach(o => o.classList.remove('is-active'));
        document.body.style.overflow = '';
      }
    });
    window.glossaryGlobalCloseAttached = true;
  }
}

document.addEventListener('DOMContentLoaded', initAllGlossaryDrawers);

document.addEventListener('shopify:section:load', (event) => {
  setTimeout(initAllGlossaryDrawers, 50);
});